// extracted by mini-css-extract-plugin
module.exports = {"form-details-container":"CreditCheckDetails_form-details-container__f_2Hu","pb-1":"CreditCheckDetails_pb-1__QzihO","pb-6":"CreditCheckDetails_pb-6__I6SlN"};